import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";
import { Deliver } from "styles/General.styled";
import { CardWrap, Column, Card, CardFooter } from "styles/MainCards.styled";
import { SortSum, SortGroup, SortItem, SortWrap } from "components/Sort/styled";
import { CheckboxIcon, CheckboxText } from "shared/Checkbox/styled";
import { InputWrap } from "shared/Input/styled";
import { SearchWrap } from "shared/SearchForm/styled";
import { PaginationWrap } from "components/Pagination/styled";

export const ListDropdown = styled.div`
  font-family: ${fonts.robotoMedium};
  color: ${colors.GREY_DARK};
  .column {
    padding: 12px 15px;
    width: 100%;
  }
  input {
    font-family: inherit;
    color: inherit;
    ::placeholder,
    ::-webkit-input-placeholder {
      color: inherit;
    }
  }
  ${CheckboxIcon} {
    margin-right: 13px;
    flex: 0 0 24px;
  }
  ${CheckboxText} {
    color: ${colors.GREY_DARK};
  }
  @media (min-width: 769px) {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0 -10px;
    .column {
      max-width: 25%;
      flex: 0 0 25%;
      padding: 12px 12px;
    }
  }
`;

export const CardWrapType1 = styled(CardWrap)`
  @media (min-width: 769px) {
    margin-left: -8px;
    margin-right: -8px;
    padding-bottom: 19px;
  }
  ${Column} {
    margin: 0 0 15px;
    @media (min-width: 769px) {
      padding-left: 8px;
      padding-right: 8px;
      flex: 0 0 25%;
      max-width: 25%;
      margin-bottom: 31px;
    }
  }
  ${Card} {
    padding: 0;
  }
  ${CardFooter} {
    margin-top: 8px;
    @media (min-width: 769px) {
      margin-top: 16px;
    }
  }
`;

/* Style SearchFormWrap */
export const SearchFormWrap = styled.div`
  margin: 40px 0 0;
  padding-bottom: 14px;

  ${SearchWrap} {
    ${InputWrap} {
      input {
        border: 0px;
        border-bottom: 1px solid #dcdee0;
        border-radius: 0px;
      }
    }
  }

  @media (min-width: 769px) {
    border: none;
    padding: 0;
  }
`;

/* Style SortWrapType1 */
export const SortWrapType1 = styled.div`
  margin: 24px 0 16px;
  ${SortItem} {
    &:last-of-type {
      display: none;
    }
  }
  ${SortSum} {
    font-size: 20px;
    font-family: ${fonts.robotoMedium};
    @media (min-width: 769px) {
      font-size: 24px;
    }
  }
  ${SortGroup} {
    display: none;
    @media (min-width: 769px) {
      display: flex;
    }
  }

  @media (min-width: 769px) {
    margin: 32px 0 26px;
  }
`;

/* Style SortWrapType2 */
export const SortWrapType2 = styled.div`
  ${SortItem} {
    &:last-of-type {
      display: none;
    }
  }
  ${SortSum} {
    display: none;
  }
  ${SortWrap} {
    margin: 0;
  }
  @media (min-width: 769px) {
    display: none;
  }
`;

/* Style DeliverType1 */
export const DeliverType1 = styled(Deliver)`
  margin: 20px 0;
  border-color: ${colors.GREY_LIGHT};
`;

/* Style PaginationType1 */
export const PaginationType1 = styled.div`
  padding: 23px 0 8px;
`;

/* Style SearchCear */
export const SearchCear = styled.div`
  display: inline-block;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`;

/* Style Tag */
export const Tag = styled.div`
  padding: 9px 21px;
  border-radius: 5px;
  font-family: ${fonts.robotoMedium};
  text-transform: uppercase;
  background-color: ${colors.RED_LIGHT};
  color: ${colors.RED};
`;

/* Style SearchTools */
export const SearchTools = styled.div`
  display: flex;
  align-items: center;
  line-height: 0.8em;
  padding: 10px 0;
  margin: 0 -8px;
  > * {
    margin: 5px 8px;
  }
`;

/* Style ButtonFiltering */
export const ButtonFiltering = styled.div`
  button {
    font-size: 0;
    padding: 11px;
    width: 46px;
    height: 46px;
    line-height: 0.7em;
    .icon {
      margin: 0;
    }
  }
  @media (min-width: 769px) {
    display: none;
  }
`;

/* Style SearchFilterWrap */
export const SearchFilterWrap = styled.div`
  padding: 5px 0 8px;
`;
/* Style Title */
export const Title = styled.div`
  font-size: 18px;
  font-family: ${fonts.abhayaRegular};
  margin-bottom: 13.5px;
  color: ${colors.GREY_SEMIDARK};
`;

/* Style GroupFiltering */
export const GroupFiltering = styled.div`
  position: relative;
  z-index: 1;
  margin-top: 31px;
  padding-bottom: 27px;
  border-bottom: 2px solid ${colors.GREY_LIGHT};
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${SearchFilterWrap} {
      display: none;
      position: absolute;
      top: 100%;
      background-color: ${colors.WHITE};
      left: -15px;
      right: -15px;
    }
    &.isDropDown {
      ${SearchFilterWrap} {
        display: block;
      }
    }
  }
  @media (min-width: 769px) {
    margin-top: 0;
    padding-bottom: 0;
    border: none;
  }
`;

/* Style SearchResultWrap */
export const SearchResultWrap = styled.div`
  padding: 30px 0 8px;
  ${CardWrapType1} {
    padding-bottom: 0;
    ${Column} {
      margin-bottom: 26px;
    }
  }
  @media (min-width: 769px) {
    padding: 46px 0 8px;
  }
`;

/* Style SliderWrap */
export const SliderWrap = styled.div``;

export const EmptyResultsMessage = styled.div`
  flex: 1;
  padding: 20px;
  text-align: center;
  font-family: ${fonts.latoBold};
  font-size: 18px;
  color: ${colors.GREY_DARK};
`;

export const Wrapper = styled.div`
  ${PaginationWrap} {
    float: right;
  }
  @media (max-width: 769px) {
    .slick-track {
      width: 100% !important;
      display: flex;
      justify-content: space-around !important;
      .slick-slide {
        width: 50%;
        div {
          display: flex;
          justify-content: center;
        }
      }
    }
    .slick-track:after {
      display: none;
    }
  }
`;
